import template from "./cost-modal.html";

const CostModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class CostModalController {
    /* @ngInject */
    constructor($rootScope, $filter, Notification, Cost) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.NotificationService = Notification;
      this.Cost = Cost;
    }

    $onInit() {
      this.cost = this.resolve.cost instanceof this.Cost ? angular.copy(this.resolve.cost) : new this.Cost();
      this.saving = false;
      if (!this.cost.currency) this.setCurrency(this.$rootScope.organization.settings.currency);
    }

    setCurrency(oldCurrency, newCurrency) {
      this.cost.currency = newCurrency || oldCurrency;
    }

    async save() {
      if (!this.form.$valid) return;
      this.saving = true;
      await this.cost.save();
      this.saving = false;
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.saveCost"),
      });
      this.close({ $value: this.cost });
      this.$rootScope.$applyAsync();
    }
  },
};

export default CostModalComponent;
